import { z } from 'zod';

export const ConsumerConversationLastMessageSchema = z.object({
  kind: z.enum(['text', 'image', 'video', 'audio']),
  /** Text (kind=text) or caption (kind=image|video, may be null when no caption was set). */
  text: z.string().min(1).nullable(),
  sentAt: z.iso.datetime(),
  authorKind: z.enum(['consumer', 'staff']),
});
export type ConsumerConversationLastMessage = z.infer<typeof ConsumerConversationLastMessageSchema>;

export const ConsumerConversationListItemSchema = z.object({
  conversationId: z.uuid(),
  tenantId: z.uuid(),
  placeId: z.uuid(),
  placeName: z.string().min(1),
  updatedAt: z.iso.datetime(),
  lastMessage: ConsumerConversationLastMessageSchema.nullable(),
  /** Staff messages after the consumer read cursor. */
  unreadCount: z.number().int().nonnegative(),
});
export type ConsumerConversationListItem = z.infer<typeof ConsumerConversationListItemSchema>;

export const ConsumerConversationsResponseSchema = z.object({
  items: z.array(ConsumerConversationListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int().positive(),
  }),
});
export type ConsumerConversationsResponse = z.infer<typeof ConsumerConversationsResponseSchema>;
